import { useTypedRouteLoaderData } from 'remix-typedjson';
import { type loader as rootLoader } from '#speaker-shop/root';

/**
 * Returns a function that prefixes a path with the voice slug
 * when in SINGLE_SUBDOMAIN mode. In SEPARATE_SUBDOMAINS mode
 * or on the landing page, the path is returned unchanged.
 *
 * Use with translatePath for voice-specific links:
 *   translatePath(voicePath('/testimonials'))
 *
 * Do NOT use for non-voice-specific pages like /gtc or /imprint.
 */
export function useVoicePath(): (path: string) => string {
    const rootData = useTypedRouteLoaderData<typeof rootLoader>('root');
    const voiceSlug =
        rootData && 'voiceSlug' in rootData && rootData.shopMode === 'SINGLE_SUBDOMAIN' && rootData.voiceSlug
            ? rootData.voiceSlug
            : undefined;

    return (path: string) => {
        if (!voiceSlug) {
            return path;
        }
        if (path === '/') {
            return `/${voiceSlug}`;
        }
        return `/${voiceSlug}${path}`;
    };
}
